


























import { Component, Watch, Vue } from 'vue-property-decorator';
import { PromotionSegment, Totals, TotalSegment } from '@/store/models';
import cart from '@/store/modules/cart';

@Component
export default class DiscountsComp extends Vue {
  private isPromoOpened = false;

  get promoSegments(): PromotionSegment[] {
    const segments: PromotionSegment[] = cart.totals.extension_attributes.blackbox_response.promotions;
    return segments
      .filter(segment => { return segment.value && segment.value > 0 } )
      .sort((a: any, b: any) => a.value > b.value ? -1 : (b.value > a.value  ? 1 : 0));
  }

  get totalsSegments(): TotalSegment[] {
    const totalSegments = cart.totals.total_segments;
    const showable = [
      'fidelity_discount',
      'tdy_gift_discount',
      'gift_discount',
    ];
    return totalSegments
      .filter(ts => ts.value && ts.value !== 0 && showable.includes(ts.code))
      .sort((a: any, b: any) => a.value > b.value ? -1 : (b.value > a.value  ? 1 : 0));
  }
}
